module.exports = __webpack_public_path__ + "static/media/buycoin.8a78c2a9.svg";